var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{staticClass:"d-activity-timestamp text-grey-dark"},[_vm._v(_vm._s(_vm.activity.time_ago)+" ago")])
}
var staticRenderFns = []

export { render, staticRenderFns }